import React from 'react'
import './background.css'

function Background() {
  return (
    <div className="background">
      <div className="home-whiteCircle"/>
      <div className="home-blueCircle"/>
      <div className="home-upperLine"/>
      <div className="home-lowerLine"/>
      <div className="about-blueCircle"/>
      <div className="timeline-whiteCircle"/>
      <div className="projects-orangeCircle"/>
    </div>
  )
}

export default Background
